namespace('IO.Views.Preferences', function (exports) {
  'use strict';

  exports.New = IO.Views.Preferences.Edit;
});
